export default "__VITE_ASSET__TH5T6zZQ__"